/* eslint-disable no-use-before-define */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext } from "react";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import { ModalContext } from "../../context/modal";
import { authApi } from "../../services/api";
import { TOASTIFY_OPTIONS } from "../../style/global";
import { DefaultButton, MyModalBody } from "../../style/default";

function ModalLandbotDelete({ open, data, populateTable }) {
  const { handleOpenModal } = useContext(ModalContext);

  const handleLandbotDelete = async () => {
    try {
      if (!data?._id) {
        toast.error("Houve um erro interno!", TOASTIFY_OPTIONS);
        return;
      }
      const reqData = await authApi.post("/landbotchannel/delete", {
        _id: data?._id,
      });
      if (reqData.status === 200) {
        populateTable();
        handleOpenModal();
        toast.success("Canal landbot deletado com sucesso.", TOASTIFY_OPTIONS);
      }
    } catch (error) {
      toast.error("Houve um erro interno.", TOASTIFY_OPTIONS);
      handleOpenModal();
    }
  };

  return (
    <Modal show={open} onHide={handleOpenModal} size="lg" backdrop="static">
      <Modal.Header closeLabel="" closeButton>
        <Modal.Title>
          Exclusão do canal: {data?.channelToken}{" "}
          {data?.accountName.length ? `(${data?.accountName})` : ""}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <MyModalBody>
          <span>
            {" "}
            Deseja realmente deletar o canal {data?.channelToken}{" "}
            {data?.accountName.length ? `(${data?.accountName})` : ""} ? Essa
            ação é <span style={{ color: "red" }}>irreversível.</span>
          </span>
        </MyModalBody>
      </Modal.Body>
      <Modal.Footer>
        <DefaultButton onClick={handleLandbotDelete}>Excluir</DefaultButton>
      </Modal.Footer>
    </Modal>
  );
}

export { ModalLandbotDelete };
